import { Component, OnInit } from '@angular/core';
import { FnModalService, FnToasterService, FnUtilService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { UtilitySetupService } from '../../setup/utility-setup/utility-setup.service';

@Component({
  selector: 'app-alert-compare',
  templateUrl: './alert-compare.component.html',
  styleUrls: ['./alert-compare.component.scss']
})
export class AlertCompareComponent implements OnInit {
  envArray: any[] = [];
  statusType: any[] = [];
  _selectEnv: string = '';
  environment: string = '';
  firstCompareData: any[] = [];
  firstData: any[] = [];
  secondData: any[] = [];
  searchFirstCompareData: any[] = [];
  searchSecondCompareData: any[] = [];
  searchTerm = '';
  firstPagedData: any[] = [];
  firstPagination = {
    currentPage: 1,
    pageSize: 15,
    totalSize: 0
  };

  secondCompareData: any[] = [];
  secondPagedData: any[] = [];
  secondPagination = {
    currentPage: 1,
    pageSize: 15,
    totalSize: 0
  };

  constructor(
    private posHttpSvcs: PosHttpService,
    private toaster: FnToasterService,
    private utilitySetup: UtilitySetupService,
    private dialogSvcs: FnModalService
  ) { }

  ngOnInit() {
    this.getUtilityEnvSet();
  }

  searchOnRows(searchTerm: string): void {
    this.searchTerm = searchTerm.toLowerCase();

    const deepSearch = (obj: any): boolean => {
      if (typeof obj === 'object' && obj !== null) {
        return Object.values(obj).some(value => deepSearch(value));
      } else if (Array.isArray(obj)) {
        return obj.some(item => deepSearch(item));
      } else {
        return obj?.toString().toLowerCase().includes(this.searchTerm);
      }
    };
    this.firstCompareData = this.searchFirstCompareData.filter(row => deepSearch(row));
    this.secondCompareData = this.searchSecondCompareData.filter(row => deepSearch(row));

    this.common();
  }
  closeSearch() {
    this.firstCompareData = [...this.searchFirstCompareData];
    this.secondCompareData = [...this.searchSecondCompareData];
    this.common();
  }

  loadInitialData() {
    this.posHttpSvcs.authPost('v1/ui/compareAlerts', 'compareAlerts', this.selectEnv).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error("Issue in fetching alerts");
        return;
      }
      this.firstData = resp.data.firstCompareData;
      this.secondData = resp.data.secondCompareData;

      this.searchFirstCompareData = [...this.firstData];
      this.searchSecondCompareData = [...this.secondData];

      this.firstCompareData = [...this.firstData];
      this.secondCompareData = [...this.secondData];

      this.common();
    })
  }

  get selectEnv(): string {
    return this._selectEnv;
  }

  set selectEnv(envUrl: string) {
    this._selectEnv = envUrl;

    const envObj = this.envArray.find(env => env.url === envUrl);
    this.environment = envObj?.name || '';
    this.loadInitialData();
  }

  getUtilityEnvSet() {
    this.utilitySetup.getUtilitySetup().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.envArray = resp.data.allEnvList;
    });
  }

  updateFirstPagedData() {
    const start = (this.firstPagination.currentPage - 1) * this.firstPagination.pageSize;
    const end = start + this.firstPagination.pageSize;
    this.firstPagedData = this.firstCompareData.slice(start, end);
  }

  updateSecondPagedData() {
    const start = (this.secondPagination.currentPage - 1) * this.secondPagination.pageSize;
    const end = start + this.secondPagination.pageSize;
    this.secondPagedData = this.secondCompareData.slice(start, end);
  }

  onFirstPageChange(page: number) {
    this.firstPagination.currentPage = page;
    this.updateFirstPagedData();
  }

  onSecondPageChange(page: number) {
    this.secondPagination.currentPage = page;
    this.updateSecondPagedData();
  }

  common() {
    this.firstPagination.totalSize = Math.ceil(this.firstCompareData.length / this.firstPagination.pageSize);
    this.secondPagination.totalSize = Math.ceil(this.secondCompareData.length / this.secondPagination.pageSize);
    this.firstPagination.currentPage = 1;
    this.secondPagination.currentPage = 1;
    this.updateFirstPagedData();
    this.updateSecondPagedData();
  }

  alertMoveFirstEnv(row: any) {
    const dialogRef = this.dialogSvcs.openConfirmModal({
      isConformationMdl: true,
      content:
        `Are you sure you want to move alert ?`,
      type: 'danger',
    });
    dialogRef.afterClosed().subscribe(doAction => {
      if (doAction) {
        const movePkt = {
          url: this.selectEnv,
          alert: row.idenNo,
          isLocal: false
        };
        this.posHttpSvcs.authPost('v1/ui/moveAlerts', 'moveAlerts', movePkt).subscribe((resp => {
          if (resp.isError) {
            this.toaster.error('Issue in Alert Move ⚠️');
            return;
          } else {
            const exists = this.secondCompareData.some(item => item.primaryKey === row.primaryKey);
            if (!exists) {
              this.secondCompareData.push(row);
              this.toaster.success('Alert moved ');
            } else {
              this.toaster.warning('Alert already present here');
              return;
            }
          }
        }));
      }
    });
    this.common();
  }

  alertMoveSecondEnv(row: any) {
    const dialogRef = this.dialogSvcs.openConfirmModal({
      isConformationMdl: true,
      content:
        `Are you sure you want to move alert ?`,
      type: 'danger',
    });
    dialogRef.afterClosed().subscribe(doAction => {
      if (doAction) {
        const movePkt = {
          url: this.selectEnv,
          alert: row.idenNo,
          isLocal: true
        };
        this.posHttpSvcs.authPost('v1/ui/moveAlerts', 'moveAlerts', movePkt).subscribe((resp => {
          if (resp.isError) {
            this.toaster.error('Issue in Alert Move ⚠️');
            return;
          } else {
            const exists = this.firstCompareData.some(item => item.primaryKey === row.primaryKey);
            if (!exists) {
              this.firstCompareData.push(row);
              this.toaster.success('Alert moved ');
            } else {
              this.toaster.warning('Alert already present there');
              return;
            }
          }
        }));
      }
    });
    this.common();
  }
}

